import type { TeamMember } from "../types";

export const getTeamMemberDisplayName = (member: TeamMember): string => {
  return member.worker?.displayName || "Unnamed Worker";
};

export const getTeamMemberInitials = (member: TeamMember): string => {
  const displayName = member.worker?.displayName || "";
  return displayName
    .split(" ")
    .map((n) => n[0])
    .join("");
};
